import React from 'react';

import { Dialog } from './Dialog';
import { DialogProps } from './Dialog';
import { Button } from '../Button';
import { UseZodFormReturn } from '@repo/hooks/useZodForm';

interface DeleteDialogProps extends DialogProps {
  icon?: boolean;
  submitText: string;
  cancelText: string;
  form?: UseZodFormReturn;
  deleteOnClick?: () => unknown;
}

export function DeleteDialog({
  isOpen,
  setIsOpen,
  title,
  form,
  icon = true,
  children,
  submitText,
  cancelText,
  deleteOnClick,
}: DeleteDialogProps) {
  return (
    <Dialog isOpen={isOpen} setIsOpen={setIsOpen} form={form} centered>
      <div className="flex flex-col items-center mx-auto w-full sm:col-span-2">
        {icon && (
          <div className="grid px-5 py-4 mb-2.5 bg-red-100 rounded-full place-items-center">
            <span className="block text-3xl text-red-700 material-symbols-outlined">warning</span>
          </div>
        )}
        <span className={`block mb-5 text-xl font-bold text-center sm:text-2xl`}>{title}</span>
      </div>
      {children}

      <div className="flex flex-col-reverse gap-5 justify-center items-center mx-auto w-full sm:col-span-2 sm:flex-row">
        <Button variant="secondary" disabled={false} onClick={() => setIsOpen?.(false)}>
          {cancelText}
        </Button>
        {deleteOnClick ? (
          <Button variant="danger" disabled={false} onClick={deleteOnClick}>
            {submitText}
          </Button>
        ) : (
          <Button variant="danger" type="submit" disabled={false}>
            {submitText}
          </Button>
        )}
      </div>
    </Dialog>
  );
}
